import { render, staticRenderFns } from "./MapPagesGroup.vue?vue&type=template&id=97cbd9ae"
import script from "./MapPagesGroup.vue?vue&type=script&lang=ts"
export * from "./MapPagesGroup.vue?vue&type=script&lang=ts"
import style0 from "./MapPagesGroup.vue?vue&type=style&index=0&id=97cbd9ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports